import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { loadFlag } from "@odin/assets";
import { localeToFlagCode } from "@odin/services";
import { defineComponent, openBlock, createElementBlock, createCommentVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
import { normalizeClass } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
const _hoisted_1 = ["src", "alt"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsCountryFlag",
  props: {
    country: { type: String, default: "" },
    size: { type: String, default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const flagImage = ref("");
    async function getImage() {
      try {
        flagImage.value = await loadFlag(localeToFlagCode(props.country).toUpperCase());
      } catch (err) {
        console.error(`Country flag not found (${props.country.toUpperCase()}).`);
        console.error(err);
      }
    }
    getImage();
    return (_ctx, _cache) => {
      return __props.country ? (openBlock(), createElementBlock("img", {
        key: 0,
        class: normalizeClass(["ws-country-flag", __props.size]),
        src: flagImage.value,
        alt: __props.country
      }, null, 10, _hoisted_1)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsCountryFlag.vue.es2.js.map
